import React, { useEffect, useState } from "react";
import { Layout, Alert, Form, Row, Col, notification, Switch } from "antd";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

/* CUSTOM COMPONENT */
import LoginHeader from "../LoginHeader/LoginHeader";
import {
  SiteLayoutBackground,
  Left,
  Right,
  LoginBox,
  XContent,
  SignIn,
  TextBox,
  XButton,
  FormItem,
  SignUpDiv,
  SignUpLink,
  SocialButton,
} from "./SignUpStyle";
/* Actions */
import { FaceBookIcon, GoogleIcon } from "../CustomIcons";
import { BlankSpace } from "../Xcomponent";

const DoctorDetail = (props) => {
  console.log("Doctor Props", props);
  const [form] = Form.useForm();

  const handleNext = (values) => {
    props.saveData("doctorDetails", values);
    props.handleNext(values);
  };

  const validateMobileNumber = (_, value) => {
    if (!value || /^[6-9]\d{9}$/.test(value) || value.length===10) {
      return Promise.resolve();
    }
    return Promise.reject(
      "Please enter valid phone number"
    );
  };

  useEffect(() => {}, []);

  return (
    <>
      {/* {saveDoctorState.apiState === "error" && */}
      {/* // <Alert style={{ marginBottom: 8 }} message={saveDoctorState.message} type="error" showIcon />} */}
      <Form
        layout="vertical"
        onFinish={handleNext}
        initialValues={props.formData.doctorDetails}
      >
        <Row gutter={[20, 20]}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <FormItem
              label="First Name"
              name="fname"
              rules={[{ required: true, message: "Please enter first name" }]}
            >
              <TextBox name="fname" size="large" />
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <FormItem
              label="Last Name"
              name="lname"
              rules={[{ required: true, message: "Please enter last name" }]}
            >
              <TextBox name="lname" size="large" />
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <FormItem
              label="Phone Number"
              name="mobile_number"
              rules={[
                { required: true, message: "Please enter phone number" },
                { validator: validateMobileNumber },
              ]}
            >
              <TextBox name="mobile_number" maxLength={10} size="large" />
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <FormItem
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter email id" },
                { type: "email", message: "Please enter valid email id" },
              ]}
            >
              <TextBox name="email" size="large" />
            </FormItem>
          </Col>
        </Row>
        <Row className="mt-3" gutter={[20, 20]}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <FormItem>
              <XButton htmlType="submit" type="primary" size="large" className="borderPrimary" block>
                Next
              </XButton>
            </FormItem>
          </Col>
        </Row>
        <Row gutter={[20, 20]}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <FormItem>
              <SignUpDiv>
                <label>
                  Already have an account?
                  <SignUpLink to={"login"}>Sign In</SignUpLink>
                </label>
              </SignUpDiv>
            </FormItem>
          </Col>
        </Row>
        <BlankSpace />
        <BlankSpace />
      </Form>
    </>
  );
};

export default DoctorDetail;
